import React, { useMemo } from 'react'
import { Tabs } from 'transfix-ui/components/Tabs'
import { ITabProps } from 'transfix-ui/components/Tabs/components/Tab'
import { TABS } from 'apps/fleet-planner/constants/loads'

interface StatusTabsProps {
  tab: string
  children: React.ReactNode
  groupedStatusCount: number[]
  tabChangeHandler: (newTab: string) => void
}

export const StatusTabs: React.FC<StatusTabsProps> = ({
  children,
  groupedStatusCount,
  tab,
  tabChangeHandler,
}) => {
  const tabList: ITabProps[] = useMemo(
    () =>
      TABS.map((label, index) => {
        return {
          tabId: label,
          label,
          count: groupedStatusCount[index] || 0,
        }
      }),
    [groupedStatusCount, TABS]
  )

  return (
    <Tabs activeTabId={tab} onChange={tabChangeHandler} tabList={tabList}>
      {children}
    </Tabs>
  )
}
export default StatusTabs
